import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { MyDatePicker } from "mydatepicker";
import { AppService } from "../services/app.service";
import { PatientFormService } from "../services/patient-form.service";
import { environment } from "../../environments/environment";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { IMyDpOptions,IMyInputFocusBlur } from "mydatepicker";
import * as AWS from "aws-sdk/global";
import * as S3 from "aws-sdk/clients/s3";
import { Router } from "@angular/router";
import { DatePipe } from "@angular/common";
import { ToastrService } from "ngx-toastr";
import { ChangeDetectorRef } from "@angular/core";
import { mobiscroll, MbscDatetimeOptions } from '@mobiscroll/angular';

mobiscroll.settings = {
  theme: 'ios',
  themeVariant: 'light'
};

@Component({
  selector: "app-patient-profile",
  templateUrl: "./patient-profile.component.html",
})
export class PatientProfileComponent implements OnInit {
  yesSelected = true;
  noSelected: boolean;
  later = false;
  answered = true;
  type: any;
  insuranceList: any;
  medicalqnslist: any = [];
  insuranceShow = true;
  couldFrontURL = environment.cloudFrontURL;
  patientProfileinfosubmit = false;
  patientProfileForm: FormGroup;
  validationMessage: any = {};
  countryList: any = [];
  selectedlang: any;
  message: any;
  errorMessage: any;
  today = new Date();
  currentDate: number;
  currentMonth: number;
  currentYear: number;
  showPrimaryCarePhysician = false;
  imgExtension = "";
  fileName = "";
  fileExtenstion = "";
  uploading = false;
  request: any;
  prescriptionImageDetail = { fileName: null, type: null };
  prescriptionUrl = "";
  prescriptionId = "";
  schedInsurance = [];
  showPatient = true;
  showInsurance = true;
  showPhysician = true;
  phonemask: any;
  customerphonemask: any;
  physicianphonemask: any;
  dob: any;
  zipcodename = "Pincode";
  physicianFaxPhnmask = "";
  phyStateList: any = [];
  stateList: any = [];
  duplicateHeder = "";
  medicalqnsList: any = [];
  physicianDiv = true;
  scheduleDateShow: any;
  scheduledpatient: any = {};
  scheduleappointmentid: any;
  testCountryCode = "";
  cid: any;
  selected1: any;
  selected2: any;
  selected = false;
  selectedType: any;
  dataInsurancList: any = [];
  @ViewChild("validationPopup") validationPopup: TemplateRef<any>;
  @ViewChild("genderModal") genderModal: TemplateRef<any>;
  @ViewChild("state1Modal") state1Modal: TemplateRef<any>;
  @ViewChild("state2Modal") state2Modal: TemplateRef<any>;
  @ViewChild("country1Modal") country1Modal: TemplateRef<any>;
  @ViewChild("country2Modal") country2Modal: TemplateRef<any>;
  @ViewChild("countryCode1Modal") countryCode1Modal: TemplateRef<any>;
  @ViewChild("countryCode2Modal") countryCode2Modal: TemplateRef<any>;
  @ViewChild("countryCode3Modal") countryCode3Modal: TemplateRef<any>;
  @ViewChild("countryCode4Modal") countryCode4Modal: TemplateRef<any>;
  // @HostListener("window:scroll", []) onWindowScroll() {
  //   this.scrollFunction();
  // }
  modalRef: BsModalRef;
  config = {
    ignoreBackdropClick: true,
  };
  path: any;
  state1Value = "State";
  state2Value = "State";
  country1Value = "";
  country2Value = "";
  countryDialCode1 = "";
  countryDialCode2 = "";
  countryDialCode3 = "";
  countryDialCode4 = "";
  public myDatePickerOptions: IMyDpOptions = {};
  showExamdetails = false;
  @ViewChild("mydp") mydp: MyDatePicker;
  @ViewChild("mydp1") mydp1: MyDatePicker;

    dateSettings: MbscDatetimeOptions = {
      dateFormat: 'M dd, yyyy',
      display: 'center'
  };
   


  constructor(
    private appservice: AppService,
    private profileInfo: FormBuilder,
    private modalService: BsModalService,
    private router: Router,
    private datepipe: DatePipe,
    private toastr: ToastrService,
    private cdRef: ChangeDetectorRef,
    private patientFormService: PatientFormService
  ) {
    const date = this.today.getDate() - 1;
    const month = this.today.getMonth() + 1;
    const year = this.today.getFullYear();
    this.myDatePickerOptions = {
      dateFormat: "mmm dd, yyyy",
      firstDayOfWeek: "su",
      maxYear: this.today.getFullYear(),
      disableSince: { year: year, month: month, day: this.today.getDate() + 1 },
      showClearDateBtn: false,
      editableDateField: true,
      indicateInvalidDate: true,
      yearSelector:true
    };
    this.patientProfileForm = profileInfo.group({
      firstName: ["", [Validators.required]],
      lastName: ["", [Validators.required]],
      sex: ["default", [Validators.required]],
      email: [
        "",
        [Validators.required, Validators.pattern(environment.emailPattern)],
      ],
      Countrydialcode: ["default"],
      phonenumber: [
        { value: "", disabled: true },
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
      date: [{ date: null }],
      mobiledate:null,
      address1: [""],
      address2: [""],
      city: [""],
      country: ["default"],
      state: [""],
      pincode: [""],
      pinlength: [""],
      pinerror: [""],
      pinmask: [""],
      pinlabel: [""],
      insurance: [""],
      primaryCarePhysician: [""],
      idNumber: [""],
      groupNumber: [""],
      customerCountrydialcode: ["default"],
      customerServicePhn: [
        { value: "", disabled: true },
        [Validators.minLength(10), Validators.maxLength(10)],
      ],
      physicianName: [""],
      physicainLastName: [""],
      physicianPhnDialCode: ["default"],
      physicianPhn: [
        { value: "", disabled: true },
        [Validators.minLength(10), Validators.maxLength(10)],
      ],
      physicianFaxDialCode: ["default"],
      physicianFaxPhn: [
        { value: "", disabled: true },
        [Validators.minLength(10), Validators.maxLength(10)],
      ],
      physicianAddress1: [""],
      physicianAddress2: [""],
      physicianCity: [""],
      physicianCountry: ["default"],
      physicianState: [""],
      physicianPincode: [""],
      physicianpinlength: [""],
      physicianpinerror: [""],
      physicianpinmask: [""],
      physicianpinlabel: [""],
      primaryEmailValidationmessage: [""],
    });
  }
  testcentre: any;
  countryCodeNew = "";

  ngOnInit() {
    if (localStorage.getItem("countryCodeNew")) {
      this.countryCodeNew = localStorage.getItem("countryCodeNew");
    }
    this.getLanguage();
    this.getcountry();
    this.getscheduleappointmentId();
  }

  getCredential(file): any {
    return this.patientFormService.getCredential(this, file);
  }

  private getParams(file, fileDetails): any {
    return this.patientFormService.getParams(this, file, fileDetails);
  }

  onFileChange(event) {
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.awsUploadFile(file);
    }
  }

  awsUploadFile(file) {
    AWS.config.region = environment.awsRegion;
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: environment.awsIdentityPoolId,
    });
    if (file) {
      const that = this;
      const fileDetails = this.getCredential(file);
      if (
        fileDetails.fileExtenstion === ".png" ||
        fileDetails.fileExtenstion === ".jpg" ||
        fileDetails.fileExtenstion === ".jpeg" ||
        fileDetails.fileExtenstion === ".pdf" ||
        fileDetails.fileExtenstion === ".xls" ||
        fileDetails.fileExtenstion === ".doc" ||
        fileDetails.fileExtenstion === ".docx" ||
        fileDetails.fileExtenstion === ".xlsx"
      ) {
        this.uploading = true;
        const params = this.getParams(file, fileDetails);
        const bucket = new S3({
          params: {
            Bucket: params.Bucket,
          },
        });
        params.ContentType = file.type;
        this.request = bucket
          .upload(params)
          .on("httpUploadProgress", function (evt) {})
          .send(function (err, response) {
            that.uploading = false;
            if (response) {
              that.prescriptionId = "";
              that.prescriptionUrl = response.key;
              that.prescriptionImageDetail.fileName = fileDetails.fileName;
              that.prescriptionImageDetail.type = "prescription";
            } else {
              that.toastr.error("Image Upload Server Problem!");
            }
          });
      } else {
        that.uploading = false;
        this.toastr.error("Invalid Document " + fileDetails.fileExtenstion);
        return;
      }
    }
  }

  closePrescription() {
    this.patientFormService.closePrescription(this);
  }

  onToggleCalendar(event: any): void {
    this.patientFormService.onToggleCalendar(this, event);
  }

  onToggleCalendarForMobile(event: any): void {
    this.patientFormService.onToggleCalendarForMobile(this, event);
  }

  openGenderPopup() {
    this.patientFormService.openGenderPopup(this);
  }

  selectGenderValue(value) {
    this.patientFormService.selectGenderValue(this, value);
  }

  openState1Popup() {
    this.patientFormService.openState1Popup(this);
  }

  selectState1Value(value) {
    this.patientFormService.selectState1Value(this, value);
  }

  openState2Popup() {
    this.patientFormService.openState2Popup(this);
  }

  selectState2Value(value) {
    this.patientFormService.selectState2Value(this, value);
  }

  openCountry1Popup() {
    this.patientFormService.openCountry1Popup(this);
  }

  selectCountry1Value(value) {
    this.patientFormService.selectCountry1Value(this, value);
  }

  openCountry2Popup() {
    this.patientFormService.openCountry2Popup(this);
  }

  selectCountry2Value(value) {
    this.patientFormService.selectCountry2Value(this, value);
  }

  openCountryCode1Popup() {
    this.patientFormService.openCountryCode1Popup(this);
  }

  selectCountryCode1Value(value) {
    this.patientFormService.selectCountryCode1Value(this, value);
  }

  openCountryCode2Popup() {
    this.patientFormService.openCountryCode2Popup(this);
  }

  selectCountryCode2Value(value) {
    this.patientFormService.selectCountryCode2Value(this, value);
  }

  openCountryCode3Popup() {
    this.patientFormService.openCountryCode3Popup(this);
  }

  selectCountryCode3Value(value) {
    this.patientFormService.selectCountryCode3Value(this, value);
  }

  openCountryCode4Popup() {
    this.patientFormService.openCountryCode4Popup(this);
  }

  selectCountryCode4Value(value) {
    this.patientFormService.selectCountryCode4Value(this, value);
  }

  getscheduleappointmentId() {
    this.path = this.router.url;
    const Splitpath = this.path.split("/");
    let scheduleappointmentid;
    if (Splitpath && Splitpath.length === 3) {
      scheduleappointmentid = Splitpath[2];
    }
    this.viewpatient(scheduleappointmentid);
    this.scheduleInsuranceList(scheduleappointmentid);
    this.schedPrescription(scheduleappointmentid);
  }

  schedPrescription(id) {
    this.patientFormService.schedPrescription(this, id);
  }

  scheduleInsuranceList(id) {
    this.patientFormService.scheduleInsuranceList(this, id);
  }

  getLanguage() {
    this.appservice.getlang().subscribe((res) => {
      if (res && res["commonMsg"] && res["validationMessage"])
        this.validationMessage = res["validationMessage"];
      this.selectedlang = res["commonMsg"];
    });
  }

  showPatientDetails() {
    this.showPatient = true;
  }

  hidePatientDetails() {
    this.showPatient = false;
  }

  showInsuranceDetails() {
    console.log("show");
    
    this.showInsurance = true;
  }

  hideInsuranceDetails() {
    console.log("hide");
    
    this.showInsurance = false;
  }

  showPhysicianDetails() {
    this.showPhysician = true;
  }

  hidePhysicianDetails() {
    this.showPhysician = false;
  }

  showExams() {
    this.showExamdetails = true;
  }

  hideExams() {
    this.showExamdetails = false;
  }

  getcountry() {
    this.patientFormService.getcountry(this);
  }

  changeMask(type, value) {
    this.patientFormService.changeMask(this, type, value);
  }

  checkDialCode(dialCode): string {
    if (dialCode && dialCode.toString().trim() && dialCode === "+91") {
      return environment.indiaPhoneMask;
    } else if (dialCode && dialCode.toString().trim() && dialCode === "+1") {
      return environment.usPhoneMask;
    }
    return null;
  }

  primaryphonenumberValidationMessage() {
    this.patientFormService.primaryphonenumberValidationMessage(this);
  }

  onDateChanged(event) {
    this.patientFormService.onDateChanged(this, event);
  }

  onInputFocusBlur(event: IMyInputFocusBlur): void {
    console.log('onInputFocusBlur(): Reason: ', event. reason, ' - Value: ', event.value);
}

  onCalendarToggle(event: number) {}
  customerphonenumberValidationMessage() {
    this.patientFormService.customerphonenumberValidationMessage(this);
  }
  physicianphonenumberValidationMessage() {
    this.patientFormService.physicianphonenumberValidationMessage(this);
  }
  physicianFaxphonenumberValidationMessage() {
    this.patientFormService.physicianFaxphonenumberValidationMessage(this);
  }

  checkPatientziplength(event) {
    this.patientFormService.checkPatientziplength(this, event);
  }

  checkPhysicianziplength(event) {
    this.patientFormService.checkPhysicianziplength(this, event);
  }

  changeCountry(countryid, type, code, value) {
    if (type === "patient") {
      if (value === "reset") {
        this.patientProfileForm.controls["state"].setValue("");
        this.getStateList(countryid, "patient");
      }
      if (countryid) {
        if (countryid === 101 || countryid === "101") {
          this.patientProfileForm.controls["pinlength"].setValue(6);
          this.patientProfileForm.controls["pinerror"].setValue(false);
          this.patientProfileForm.controls["pinmask"].setValue("000000");
          this.patientProfileForm.controls["pinlabel"].setValue("Pin Code");

          if (
            this.patientProfileForm.get("Countrydialcode").value !== "default"
          ) {
            this.patientProfileForm.controls.phonenumber.enable();
            this.countryDialCode4 = this.patientProfileForm.get(
              "Countrydialcode"
            ).value;
          }
          if (
            this.patientProfileForm.get("Countrydialcode").value === "default"
          ) {
            this.patientProfileForm.controls["Countrydialcode"].setValue("+91");
            this.phonemask = "00000-00000";
            this.countryDialCode4 = "+91";
            this.patientProfileForm.controls.phonenumber.enable();
          }

          if (
            this.patientProfileForm.get("customerCountrydialcode").value !==
            "default"
          ) {
            this.patientProfileForm.controls.customerServicePhn.enable();
          }
          if (
            this.patientProfileForm.get("customerCountrydialcode").value ===
            "default"
          ) {
            this.patientProfileForm.controls[
              "customerCountrydialcode"
            ].setValue("+91");
            this.countryDialCode1 = "+91";
            this.countryDialCode2 = "+91";
            this.countryDialCode3 = "+91";

            this.customerphonemask = "00000-00000";
            this.patientProfileForm.controls.customerServicePhn.enable();
          }
        } else if (countryid === 231 || countryid === "231") {
          this.patientProfileForm.controls["pinlength"].setValue(5);
          this.patientProfileForm.controls["pinerror"].setValue(false);
          this.patientProfileForm.controls["pinmask"].setValue("00000");
          this.patientProfileForm.controls["pinlabel"].setValue("Zip Code");

          if (
            this.patientProfileForm.get("Countrydialcode").value !== "default"
          ) {
            this.patientProfileForm.controls.phonenumber.enable();
            this.countryDialCode4 = this.patientProfileForm.get(
              "Countrydialcode"
            ).value;
          }

          if (
            this.patientProfileForm.get("Countrydialcode").value === "default"
          ) {
            this.patientProfileForm.controls["Countrydialcode"].setValue("+1");
            this.phonemask = "(000) 000-0000";
            this.countryDialCode4 = "+1";
            this.patientProfileForm.controls.phonenumber.enable();
          }

          if (
            this.patientProfileForm.get("customerCountrydialcode").value !==
            "default"
          ) {
            this.patientProfileForm.controls.customerServicePhn.enable();
          }

          if (
            this.patientProfileForm.get("customerCountrydialcode").value ===
            "default"
          ) {
            this.patientProfileForm.controls[
              "customerCountrydialcode"
            ].setValue("+1");
            this.countryDialCode1 = "+1";
            this.countryDialCode2 = "+1";
            this.countryDialCode3 = "+1";
            this.customerphonemask = "(000) 000-0000";
            this.patientProfileForm.controls.customerServicePhn.enable();
          }
        }
      }
      this.patientProfileForm.controls["pincode"].setValue(code);
      this.cdRef.detectChanges();
    }

    if (type === "phy") {
      if (value === "reset") {
        this.patientProfileForm.controls["physicianState"].setValue("");
        this.getStateList(countryid, "phy");
      }
      if (countryid) {
        if (countryid === "101" || countryid === 101) {
          this.patientProfileForm.controls["physicianpinlength"].setValue(6);
          this.patientProfileForm.controls["physicianpinerror"].setValue(false);
          this.patientProfileForm.controls["physicianpinmask"].setValue(
            "000000"
          );
          this.patientProfileForm.controls["physicianpinlabel"].setValue(
            "Pin Code"
          );
          if (
            this.patientProfileForm.get("physicianPhnDialCode").value !==
            "default"
          ) {
            this.patientProfileForm.controls.physicianPhn.enable();
          }
          if (
            this.patientProfileForm.get("physicianPhnDialCode").value ===
            "default"
          ) {
            this.patientProfileForm.controls["physicianPhnDialCode"].setValue(
              "+91"
            );
            this.physicianphonemask = "00000-00000";
            this.patientProfileForm.controls.physicianPhn.enable();
          }

          if (
            this.patientProfileForm.get("physicianFaxDialCode").value !==
            "default"
          ) {
            this.patientProfileForm.controls.physicianFaxPhn.enable();
          }

          if (
            this.patientProfileForm.get("physicianFaxDialCode").value ===
            "default"
          ) {
            this.patientProfileForm.controls["physicianFaxDialCode"].setValue(
              "+91"
            );
            this.physicianFaxPhnmask = "00000-00000";
            this.patientProfileForm.controls.physicianFaxPhn.enable();
          }
        } else if (countryid === "231" || countryid === 231) {
          this.patientProfileForm.controls["physicianpinlength"].setValue(5);
          this.patientProfileForm.controls["physicianpinerror"].setValue(false);
          this.patientProfileForm.controls["physicianpinmask"].setValue(
            "00000"
          );
          this.patientProfileForm.controls["physicianpinlabel"].setValue(
            "Zip Code"
          );

          if (
            this.patientProfileForm.get("physicianPhnDialCode").value !==
            "default"
          ) {
            this.patientProfileForm.controls.physicianPhn.enable();
          }
          if (
            this.patientProfileForm.get("physicianPhnDialCode").value ===
            "default"
          ) {
            this.patientProfileForm.controls["physicianPhnDialCode"].setValue(
              "+1"
            );
            this.physicianphonemask = "(000) 000-0000";
            this.patientProfileForm.controls.physicianPhn.enable();
          }
          if (
            this.patientProfileForm.get("physicianFaxDialCode").value !==
            "default"
          ) {
            this.patientProfileForm.controls.physicianFaxPhn.enable();
          }
          if (
            this.patientProfileForm.get("physicianFaxDialCode").value ===
            "default"
          ) {
            this.patientProfileForm.controls["physicianFaxDialCode"].setValue(
              "+1"
            );
            this.physicianFaxPhnmask = "(000) 000-0000";
            this.patientProfileForm.controls.physicianFaxPhn.enable();
          }
        }
      }

      this.patientProfileForm.controls["physicianPincode"].setValue(code);

      this.cdRef.detectChanges();
    }
  }

  getStateList(countryid, type) {
    this.appservice.getState(countryid).subscribe(
      (res) => {
        if (type === "patient") {
          this.stateList = res["entity"];
        }
        if (type === "phy") {
          this.phyStateList = res["entity"];
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  answerLater(type) {
    this.patientFormService.answerLater(this, type);
  }
  yesornochecked(type) {
    if (type === "no") {
      this.yesSelected = false;
      this.noSelected = true;
      this.answered = false;
    }
    if (type === "yes") {
      this.noSelected = false;
      this.yesSelected = true;
      this.answered = true;
    }
  }

  checkQuestionHeader(header, i) {
    setTimeout(() => {
      let flag = "";
      let p = 0;
      if (i !== 0) {
        this.medicalqnsList[i].schedMedicalQuestions.forEach((medical) => {
          if (medical.duplicate) {
            flag = this.medicalqnsList[i].tcProcedureView.procedureName;
            p++;
            return flag;
          }
        });
        if (p === 0) {
          this.duplicateHeder += "," + header;
        }
      }
      return flag;
    }, 2000);
  }

  checkQuestion(question, i) {
    return this.patientFormService.checkQuestion(question, i, this.medicalqnsList);
  }

  getmedicalqns(scheduleappointmentid) {
    this.appservice.getmedicalqns(scheduleappointmentid).subscribe((res) => {
      if (res && res["entity"]) {
        this.medicalqnsList = res["entity"];
        if (
          this.medicalqnsList.length > 0 &&
          this.medicalqnsList[0].schedMedicalQuestions
        ) {
          const gender = (
            this.patientProfileForm.controls["sex"].value || ""
          ).toString().toLowerCase();
          for (let index = 0; index < this.medicalqnsList.length; index++) {
            this.medicalqnsList[index].schedMedicalQuestions.forEach(
              (medical) => {
                const questionGender =
                  medical.medicalQuestion &&
                  medical.medicalQuestion.medicalQuestion &&
                  medical.medicalQuestion.medicalQuestion.gender
                    ? medical.medicalQuestion.medicalQuestion.gender
                        .toString()
                        .toLowerCase()
                    : "";
                if (gender === "female" || !gender) {
                  medical.isShow = true;
                } else {
                  medical.isShow = true;
                  if (questionGender === "female") {
                    medical.isShow = false;
                  }
                }
                if (
                  medical.medicalQuestion.medicalQuestion.yesOrNoText ===
                  "false"
                ) {
                  medical.yesOrNoText = false;
                } else {
                  medical.yesOrNoText = true;
                }
                if (
                  (medical.medicalQuestion.medicalQuestion.question.indexOf(
                    "Height"
                  ) !== -1 ||
                    medical.medicalQuestion.medicalQuestion.question.indexOf(
                      "height"
                    ) !== -1) &&
                  ((medical.medicalQuestion.medicalQuestion.question.indexOf(
                    "Weight"
                  ) &&
                    -1) ||
                    (medical.medicalQuestion.medicalQuestion.question.indexOf(
                      "weight"
                    ) &&
                      -1))
                ) {
                  medical.isHeightWeight = true;
                } else {
                  medical.isHeightWeight = false;
                }
              }
            );
          }
        }
      }
    });
  }

  viewpatient(scheduleappointmentid) {
    this.appservice.viewscheduleappointment(scheduleappointmentid).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            this.scheduledpatient = res["entity"];
            if (this.scheduledpatient["countryName"] === "United States") {
              this.testCountryCode = "US";
            } else {
              this.testCountryCode = "IN";
            }
            if (
              this.scheduledpatient.patientCheckIn === true ||
              this.scheduledpatient.canceled === true ||
              this.scheduledpatient.noshow === true
            ) {
              if (this.scheduledpatient.patientCheckIn === true) {
                this.toastr.error("Appointment completed");
              }
              if (this.scheduledpatient.canceled === true) {
                this.toastr.error("Appointment cancelled");
              }
              if (this.scheduledpatient.noshow === true) {
                this.toastr.error("Appointment cancelled");
              }
              this.router.navigate(["/home"]);
              return;
            }
            this.scheduleDateShow = this.datepipe.transform(
              this.scheduledpatient.scheduledOn,
              "MMM d, y"
            );
            if (this.scheduledpatient.insuranceType === 2) {
              this.showPrimaryCarePhysician = true;
            } else {
              this.showPrimaryCarePhysician = false;
            }
            if (this.scheduledpatient.insuranceType === 3) {
              this.physicianDiv = false;
              const removephycareValidation = this.patientProfileForm.get(
                "primaryCarePhysician"
              );
              removephycareValidation.clearValidators();
              removephycareValidation.updateValueAndValidity();
            }
            this.scheduleappointmentid = scheduleappointmentid;
            if (this.scheduledpatient.payMode === "self") {
              this.insuranceShow = false;
              const removeInsValidation = this.patientProfileForm.get(
                "insurance"
              );
              removeInsValidation.clearValidators();
              const primaryCarePhysicianValidation = this.patientProfileForm.get(
                "primaryCarePhysician"
              );
              primaryCarePhysicianValidation.clearValidators();
              const idNumberValidation = this.patientProfileForm.get(
                "idNumber"
              );
              idNumberValidation.clearValidators();
              const groupNumberValidation = this.patientProfileForm.get(
                "groupNumber"
              );
              groupNumberValidation.clearValidators();
              const customercodeValidation = this.patientProfileForm.get(
                "customerCountrydialcode"
              );
              customercodeValidation.clearValidators();
              const customerPhnValidation = this.patientProfileForm.get(
                "customerServicePhn"
              );
              customerPhnValidation.clearValidators();

              removeInsValidation.updateValueAndValidity();
              primaryCarePhysicianValidation.updateValueAndValidity();
              idNumberValidation.updateValueAndValidity();
              groupNumberValidation.updateValueAndValidity();
              customercodeValidation.updateValueAndValidity();
              customerPhnValidation.updateValueAndValidity();
            }

            this.patientProfileForm.controls["firstName"].setValue(
              this.scheduledpatient.patientFirstName
            );
            this.patientProfileForm.controls["insurance"].setValue(
              this.scheduledpatient.insuranceName
            );

            this.patientProfileForm.controls["lastName"].setValue(
              this.scheduledpatient.patientLastName
            );
            this.patientProfileForm.controls["sex"].setValue(
              this.scheduledpatient.patientGender
            );
            this.patientProfileForm.controls["email"].setValue(
              this.scheduledpatient.patientEmail
            );
            this.patientProfileForm.controls["Countrydialcode"].setValue(
              this.scheduledpatient.patientPhoneCode
            );

            if (this.scheduledpatient.patientDob) {
              this.dob = this.scheduledpatient.patientDob;
            }

            this.countryDialCode1 = this.scheduledpatient.patientPhoneCode;
            this.countryDialCode2 = this.scheduledpatient.patientPhoneCode;
            this.countryDialCode3 = this.scheduledpatient.patientPhoneCode;
            this.countryDialCode4 = this.scheduledpatient.patientPhoneCode;

            this.patientProfileForm.controls["city"].setValue(
              this.scheduledpatient.patientCityName
            );

            const dataDob = new Date(this.scheduledpatient.patientDob);
            this.patientProfileForm.controls["date"].setValue(dataDob);
            
            if(this.scheduledpatient.patientDob){
              var splitDate = this.scheduledpatient.patientDob.toString().split("-");
              var patientdob = new Date();
              patientdob.setFullYear(+splitDate[0]);
              patientdob.setMonth(+splitDate[1] - 1);
              patientdob.setDate(+splitDate[2]);
              patientdob.setHours(0);
              patientdob.setMinutes(0);
              this.patientProfileForm.controls["mobiledate"].setValue(patientdob);
            console.log(patientdob);
            }
            console.log(patientdob);
            this.patientProfileForm.controls["address1"].setValue(
              this.scheduledpatient.patientAddressLine1
            );
            this.patientProfileForm.controls["address2"].setValue(
              this.scheduledpatient.patientAddressLine2
            );
            this.patientProfileForm.controls["state"].setValue(
              this.scheduledpatient.patientState
                ? this.scheduledpatient.patientState
                : ""
            );
            this.patientProfileForm.controls["physicianName"].setValue(
              this.scheduledpatient.physicianFirstName
            );
            this.patientProfileForm.controls["physicainLastName"].setValue(
              this.scheduledpatient.physicianLastName
            );
            if (this.scheduledpatient.physicianPhoneCode) {
              this.patientProfileForm.controls["physicianPhnDialCode"].setValue(
                this.scheduledpatient.physicianPhoneCode
              );
            }

            this.patientProfileForm.controls["physicianPhn"].setValue(
              this.scheduledpatient.physicianPhone
            );

            if (this.scheduledpatient.physicianFaxCode) {
              this.patientProfileForm.controls["physicianFaxDialCode"].setValue(
                this.scheduledpatient.physicianFaxCode
              );
            }
            this.patientProfileForm.controls["physicianFaxPhn"].setValue(
              this.scheduledpatient.physicianFax
            );
            this.patientProfileForm.controls["physicianAddress1"].setValue(
              this.scheduledpatient.physicianAddressLine1
            );
            this.patientProfileForm.controls["physicianAddress2"].setValue(
              this.scheduledpatient.physicianAddressLine2
            );

            this.patientProfileForm.controls["physicianCity"].setValue(
              this.scheduledpatient.physicianCityName
            );

            this.patientProfileForm.controls["physicianState"].setValue(
              this.scheduledpatient.physicianState
                ? this.scheduledpatient.physicianState
                : ""
            );

            this.patientProfileForm.controls["physicianCountry"].setValue(
              this.scheduledpatient.physicianCountry
            );

            this.patientProfileForm.controls["physicianPincode"].setValue(
              this.scheduledpatient.physicianZipCode
            );

            this.customerphonemask = this.appservice.checkDialCode(
              this.scheduledpatient.insuranceCustomerCode
            );
            this.patientProfileForm.controls.customerServicePhn.enable();

            this.patientProfileForm.controls["date"].setValue(
              this.setDateToDatePicker(this.scheduledpatient.patientDob)
            );

            
            if(this.scheduledpatient.patientDob){
              var splitDate = this.scheduledpatient.patientDob.toString().split("-");
              var patientdob = new Date();
              patientdob.setFullYear(+splitDate[0]);
              patientdob.setMonth(+splitDate[1] - 1);
              patientdob.setDate(+splitDate[2]);
              patientdob.setHours(0);
              patientdob.setMinutes(0);
              this.patientProfileForm.controls["mobiledate"].setValue(patientdob);
            console.log(patientdob);
            }
            
            if (
              this.patientProfileForm.get("Countrydialcode").value !== "default"
            ) {
              this.patientProfileForm.controls.phonenumber.enable();
              this.phonemask = this.appservice.checkDialCode(
                this.patientProfileForm.get("Countrydialcode").value
              );
            }
            this.patientProfileForm.controls["phonenumber"].setValue(
              this.scheduledpatient.patientPhone
            );

            let patientCountry = 0;
            let physicianCountry = 0;
            if (this.scheduledpatient.patientCountry) {
              if (
                this.scheduledpatient.patientCountry === 101 ||
                this.scheduledpatient.patientCountry === "101"
              ) {
                this.patientProfileForm.controls["country"].setValue(101);
                this.country1Value = "India";
                this.state1Value = this.scheduledpatient.patientStateName
                  ? this.scheduledpatient.patientStateShortName
                  : "state";
                patientCountry = 101;
              } else {
                this.patientProfileForm.controls["country"].setValue(231);
                this.country1Value = "United States";
                this.state1Value = this.scheduledpatient.patientStateName
                  ? this.scheduledpatient.patientStateShortName
                  : "state";
                patientCountry = 231;
              }
              this.getStateList(patientCountry, "patient");
              this.changeCountry(
                patientCountry,
                "patient",
                this.scheduledpatient.patientZipCode,
                ""
              );
            } else if (this.scheduledpatient.countryName === "India") {
              this.patientProfileForm.controls["country"].setValue(101);
              this.getStateList(101, "patient");
              this.country1Value = "India";
              this.changeCountry(
                101,
                "patient",
                this.scheduledpatient.patientZipCode,
                ""
              );
            } else {
              this.patientProfileForm.controls["country"].setValue(231);
              this.getStateList(231, "patient");
              this.country1Value = "United States";
              this.changeCountry(
                231,
                "patient",
                this.scheduledpatient.patientZipCode,
                ""
              );
            }

            if (this.scheduledpatient.physicianCountry) {
              if (
                this.scheduledpatient.physicianCountry === 101 ||
                this.scheduledpatient.physicianCountry === "101"
              ) {
                this.patientProfileForm.controls["physicianCountry"].setValue(
                  101
                );
                this.getStateList(101, "phy");
                this.country2Value = "India";
                this.state2Value = this.scheduledpatient.physicianStateName
                  ? this.scheduledpatient.physicianStateShortName
                  : "State";
                physicianCountry = 101;
              } else {
                this.patientProfileForm.controls["physicianCountry"].setValue(
                  231
                );
                this.getStateList(231, "phy");
                this.country2Value = "United States";
                this.state2Value = this.scheduledpatient.physicianStateName
                  ? this.scheduledpatient.physicianStateShortName
                  : "State";
                physicianCountry = 231;
              }

              this.changeCountry(
                physicianCountry,
                "phy",
                this.scheduledpatient.physicianZipCode,
                ""
              );
            } else if (this.scheduledpatient.countryName === "India") {
              this.patientProfileForm.controls["physicianCountry"].setValue(
                101
              );
              this.getStateList(101, "phy");
              this.country2Value = "India";
              this.changeCountry(
                101,
                "phy",
                this.scheduledpatient.physicianZipCode,
                ""
              );
            } else {
              this.patientProfileForm.controls["physicianCountry"].setValue(
                231
              );
              this.getStateList(231, "phy");
              this.country2Value = "United States";
              this.changeCountry(
                231,
                "phy",
                this.scheduledpatient.physicianZipCode,
                ""
              );
            }

            this.getmedicalqns(scheduleappointmentid);
          }
        } else {
          this.router.navigate(["/home"]);
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  setDateToDatePicker(dateStr) {
    return this.patientFormService.setDateToDatePicker(dateStr);
  }

  openModal(template: TemplateRef<any>) {
    this.patientFormService.openModal(this, template);
  }

  changed(value, type, index2, medicalqnslist, qnsList) {
    if (type === "yes") {
      medicalqnslist.schedMedicalQuestions[index2].selected1 = true;
      medicalqnslist.schedMedicalQuestions[index2].selected2 = false;
      medicalqnslist.schedMedicalQuestions[index2].answer1 = "";
      medicalqnslist.schedMedicalQuestions[index2].answer1 = "Yes";
    }
    if (type === "no") {
      medicalqnslist.schedMedicalQuestions[index2].selected1 = false;
      medicalqnslist.schedMedicalQuestions[index2].selected2 = true;
      medicalqnslist.schedMedicalQuestions[index2].answer1 = "";
      medicalqnslist.schedMedicalQuestions[index2].answer1 = "No";
    }
  }

  answerChange(input, qnsList) {
    this.patientFormService.answerChange(input, qnsList);
  }

  updatePatientDetails() {

    const valid = false;
    this.patientProfileinfosubmit = true;
    if (
      this.patientProfileForm.valid &&
      this.patientProfileForm.get("country").value !== "default" &&
      this.patientProfileForm.get("physicianCountry").value !== "default"
    ) {
      if (
        this.schedInsurance &&
        this.schedInsurance.length > 0 &&
        this.scheduledpatient.payMode === "insurance"
      ) {
        this.appservice
          .updateschedinsurance(this.schedInsurance)
          .subscribe((res) => ({}));
      }

      if (this.prescriptionImageDetail.type && this.prescriptionUrl) {
        const data1 = {
          id: this.scheduleappointmentid,
          schedPrescription: [
            {
              documentType: this.prescriptionImageDetail.type,
              id: this.prescriptionId,
              prescriptionImageKey: this.prescriptionUrl,
            },
          ],
        };
        this.appservice.prescriptionupload(data1).subscribe((res) => {});
      }

      const data = {
        id: this.scheduleappointmentid,
        createdOn: this.scheduledpatient.createdOn,
        scheduledOn: this.scheduledpatient.scheduledOn,
        scheduledOnStr: this.scheduledpatient.scheduledOn,
        scheduleFromTime: this.scheduledpatient.scheduleFromTime,
        scheduleToTime: this.scheduledpatient.scheduleToTime,
        payMode: this.scheduledpatient.payMode,
        choosenLocation: this.scheduledpatient.choosenLocation,
        latitude: this.scheduledpatient.latitude,
        longitude: this.scheduledpatient.longitude,
        schedMed: true,
        preAuthorized: false,
        totalAmount: this.scheduledpatient.totalAmount,
        timezone: this.scheduledpatient.timezone,
        active: true,
        deleted: false,
        reSchedule: false,
        answered: this.answered,
        physicianId: null,
        physicianFirstName: this.patientProfileForm.get("physicianName").value,
        physicianLastName: this.patientProfileForm.get("physicainLastName")
          .value,
        physicianGender: null,
        physicianEmail: null,
        physicianPhone: this.patientProfileForm.get("physicianPhn").value,
        physicianPhoneCode: this.patientProfileForm.get("physicianPhnDialCode")
          .value,
        physicianFax: this.patientProfileForm.get("physicianFaxPhn").value,
        physicianFaxCode: this.patientProfileForm.get("physicianFaxDialCode")
          .value,
        physicianDob: null,
        physicianAddressId: null,
        physicianAddressLine1: this.patientProfileForm.get("physicianAddress1")
          .value,
        physicianAddressLine2: this.patientProfileForm.get("physicianAddress2")
          .value,
        physicianAreaName: null,
        physicianCityName: this.patientProfileForm.get("physicianCity").value,
        physicianState: this.patientProfileForm.get("physicianState").value,
        physicianCountry: this.patientProfileForm.get("physicianCountry").value,
        physicianZipCode: this.patientProfileForm.get("physicianPincode").value,
        patientId: this.scheduledpatient.patientId,
        patientFirstName: this.patientProfileForm.get("firstName").value,
        patientLastName: this.patientProfileForm.get("lastName").value,
        patientGender: this.patientProfileForm.get("sex").value,
        patientEmail: this.patientProfileForm.get("email").value,
        patientPhone: this.patientProfileForm.get("phonenumber").value,
        patientPhoneCode: this.patientProfileForm.get("Countrydialcode").value,
        patientDob: (this.patientProfileForm.get("mobiledate").value && this.patientProfileForm.get("mobiledate").value != null)?this.datepipe.transform(this.patientProfileForm.get("mobiledate").value,"yyyy-MM-dd"):this.datepipe.transform(this.dob, "yyyy-MM-dd"),
        patientAddressId: null,
        patientAddressLine1: this.patientProfileForm.get("address1").value,
        patientAddressLine2: this.patientProfileForm.get("address2").value,
        patientAreaName: null,
        patientCityName: this.patientProfileForm.get("city").value,
        patientState: this.patientProfileForm.get("state").value,
        patientCountry: this.patientProfileForm.get("country").value,
        patientZipCode: this.patientProfileForm.get("pincode").value,
        testCenterId: this.scheduledpatient.testCenterId,
      };

      this.appservice.updatescheduleappointment(data).subscribe(
        (res) => {
          if (res && res["status"] && res["status"]["status"] === 200) {
            this.appservice
              .trigersmsandemail(this.scheduleappointmentid)
              .subscribe((res) => ({}));
            if (this.answered) {
              const data = {
                scheduleAppointmentId: this.scheduleappointmentid,
                tcProMedQuesOut: this.medicalqnsList,
              };
              this.appservice.addorupdateschedmedicalquestions(data).subscribe(
                (res) => {},
                (err) => {
                  this.appservice.sessionOut(err);
                }
              );
            }
            this.router.navigate([
              "/appointment-confirm",
              this.scheduleappointmentid,
            ]);
          }
        },
        (err) => {
          this.appservice.sessionOut(err);
        }
      );
    }
    if (!this.patientProfileForm.valid) {
      this.toastr.error("Please fill all the highlighted fields");
      this.validationMessage.primaryEmailValidationmessage = this.validationMessage.emailid;
      this.primaryphonenumberValidationMessage();
      this.physicianphonenumberValidationMessage();
      this.customerphonenumberValidationMessage();
      this.physicianFaxphonenumberValidationMessage();
    }
  }

  checkEmailValidationMessage(value) {}

  checkHeightWeightQus(qus, qnsList) {
    return this.patientFormService.checkHeightWeightQus(qus, qnsList);
  }
}
